(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-products"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('media-with-products')) {
      class MediaWithProducts extends HTMLElement {
        connectedCallback() {
          this.scroller = this.querySelector('.media-with-products__products');
          this.scrollContent = this.scroller?.firstElementChild;
          this.scrollUpButton = this.querySelector('.media-with-products__scroll-button--up');
          this.scrollDownButton = this.querySelector('.media-with-products__scroll-button--down');

          if (!this.scroller || !this.scrollContent || !this.scrollUpButton || !this.scrollDownButton) return;

          this.updateScrollFade = () => {
            const hasOverflow = this.scroller.scrollHeight > this.scroller.clientHeight + 1;
            const canScrollUp = hasOverflow && this.scroller.scrollTop > 1;
            const isAtEnd = this.scroller.scrollTop + this.scroller.clientHeight >= this.scroller.scrollHeight - 1;
            const canScrollDown = hasOverflow && !isAtEnd;

            this.scroller.classList.toggle('has-scroll-fade-top', canScrollUp);
            this.scroller.classList.toggle('has-scroll-fade-bottom', canScrollDown);
            this.scrollUpButton.hidden = !canScrollUp;
            this.scrollDownButton.hidden = !canScrollDown;
          };

          this.scrollProducts = (direction) => {
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            this.scroller.scrollBy({
              top: direction * Math.max(this.scroller.clientHeight * 0.7, 160),
              behavior: reducedMotion ? 'auto' : 'smooth'
            });
          };

          this.scrollUp = () => this.scrollProducts(-1);
          this.scrollDown = () => this.scrollProducts(1);

          this.scroller.addEventListener('scroll', this.updateScrollFade, { passive: true });
          this.scrollUpButton.addEventListener('click', this.scrollUp);
          this.scrollDownButton.addEventListener('click', this.scrollDown);
          this.scrollFadeResizeObserver = new ResizeObserver(this.updateScrollFade);
          this.scrollFadeResizeObserver.observe(this.scroller);
          this.scrollFadeResizeObserver.observe(this.scrollContent);
          requestAnimationFrame(this.updateScrollFade);
        }

        disconnectedCallback() {
          this.scroller?.removeEventListener('scroll', this.updateScrollFade);
          this.scrollUpButton?.removeEventListener('click', this.scrollUp);
          this.scrollDownButton?.removeEventListener('click', this.scrollDown);
          this.scrollFadeResizeObserver?.disconnect();
        }
      }

      customElements.define('media-with-products', MediaWithProducts);
    }
  
  } catch(e) { console.error(e); }
})();
})();
